var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"text-center"},[_c('label',{staticClass:"mt-3"},[_c('h4',[_vm._v(_vm._s(_vm.$t("lbl.basic.noResultMessage")))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }